import type { TComputedSubscription } from '../utils/getComputedSubscription'
import { useActiveJourneySubscriptionsQuery } from './useActiveJourneySubscriptionsQuery'
import { useEverlastingSubscriptionsQuery } from './useEverlastingSubscriptionsQuery'

export const useCommunityActiveSubscription = (communityId: number) => {
  const select = (data: TComputedSubscription[]) => data?.find((sub) => sub.community.id === communityId)
  const { data: journeySubscription } = useActiveJourneySubscriptionsQuery({ select })
  const { data: everlastingSubscription } = useEverlastingSubscriptionsQuery({ select })
  return journeySubscription || everlastingSubscription
}
